module.exports = "/_next/static/images/zec-84e427016a7e582e7e6a034d0712b05c.svg";